"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducers = void 0;
var redux_1 = require("redux");
var main_1 = __importDefault(require("./slices/main"));
var user_1 = __importDefault(require("./slices/user"));
var lot_1 = __importDefault(require("./slices/lot"));
var auction_1 = __importDefault(require("./slices/auction"));
var bid_1 = __importDefault(require("./slices/bid"));
var bidder_1 = __importDefault(require("./slices/bidder"));
var countdown_1 = __importDefault(require("./slices/countdown"));
var summary_1 = __importDefault(require("./slices/summary"));
exports.reducers = (0, redux_1.combineReducers)({
    //TODO add more as needed
    mainState: main_1.default,
    userState: user_1.default,
    lotState: lot_1.default,
    auctionState: auction_1.default,
    bidState: bid_1.default,
    bidderState: bidder_1.default,
    countdownState: countdown_1.default,
    summaryState: summary_1.default,
});
